import React, {useState, useEffect} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import {useOktaAuth} from '@okta/okta-react';
import axios from 'axios';
import {useContextProvider} from "../ContextProvider";
import CircularProgress from '@mui/material/CircularProgress';
import {useFuelAutocompleteProps, FuelAutocompleteValue} from '@deere/fuel-react/useFuelAutocompleteProps';
export const SearchSupplierEmpComponent = () => {

    const DEFAULT_OPTIONS=[{"type":"EDI_Type","code":"TRADITIONAL","name":"Traditional"},{"type":"EDI_Type","code":"WEB","name":"Web"},{"type":"EDI_Type","code":"MULTIPLE","name":"Multiple"}];
    const {searchValue, setSearchValue} = useContextProvider();
    const [searchOptions, setSearchOptions] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [units, setUnits] = useState([]);
    const [transactions, setTransactions] = useState([]);
    const [searchReady,isSearchReady]=useState(true);
    const {oktaAuth} = useOktaAuth();
    const [inputValue, setInputValue] = useState("");
    const [valueToSearch, setValueToSearch] = useState("");
    const token = oktaAuth.getAccessToken();
    const [open, setOpen] = useState(false);

    const removeLeadingZeros = (stringValue) => stringValue?.replace(/^00+/, '0');
    const loading = open && searchOptions.length === 0;

    useEffect(() => {
        const fetchSupplierData = async () => {
             await axios.get(process.env.REACT_APP_API_BASE_URL + "/getSupplierInfoEmployee?queryString=" + valueToSearch,
                {
                    params: {
                        _limit: 5
                    },
                    headers: {
                        'Authorization': 'Bearer ' + token
                    }
                }).then((response)=>{
                const data = response.data.map((supp) => {
                    const {supplierNumber, supplierName} = supp;
                    return {
                        "code": supplierNumber,
                        "name": supplierName,
                        "type": "Supplier"
                    };
                });
                setSuppliers(data);
            }).catch((error)=>{
                setSuppliers([]);
                console.log(error);
            });

        }

        const fetchTransTypeData = async () => {
            await axios.get(process.env.REACT_APP_EDI_SETUP_DETAILS_BASE_URL + "/api/tpload/transtype/list?queryString=" + valueToSearch,
                {
                    headers: {
                        'Authorization': 'Bearer ' + token
                    }
                }).then((response)=>{
                setTransactions(response.data);
            }).catch((error)=>{
                setTransactions([]);
                console.log(error);
            })

        }

        const fetchUnitData = async () => {
            await axios.get(process.env.REACT_APP_EDI_SETUP_DETAILS_BASE_URL +"/api/tpload/unit/list?queryString=" + valueToSearch,
                {
                    headers: {
                        'Authorization': 'Bearer ' + token
                    }
                }).then((response)=>{
                setUnits(response.data);
            }).catch((error)=>{
                setUnits([]);
                console.log(error);
            })

        }


        if (valueToSearch.length >= 2) {
            isSearchReady(false);
            fetchUnitData().then(()=>{
                if (valueToSearch.length >= 3){
                    fetchTransTypeData().then(()=>{
                        fetchSupplierData().then(()=>{
                            isSearchReady(true);
                        });
                    });
                }
            });

        }
        else {
            setSearchOptions(DEFAULT_OPTIONS);
        }

    }, [valueToSearch]);


    useEffect(() => {
        if (searchValue.length===0){
                setSuppliers([]);
                setUnits([]);
                setTransactions([]);
                setSearchOptions(DEFAULT_OPTIONS);
                setValueToSearch("");
            }
    }, [searchValue]);

    useEffect(()=>{
        if (suppliers.length>0 || units.length>0 || transactions.length){
            const options=transactions.concat(units).concat(suppliers);
            setSearchOptions(options);
        }


    },[units,suppliers,transactions]);

    return (

        <Autocomplete multiple options={searchOptions}
                      getOptionLabel={(option) => {
                          if (option.type!=="EDI_Type" && option.type!=="isa" && option.type!=="gs"){
                              return option.code + " - " + option.name;
                          }

                          else {
                              return option.name;
                          }

                      }}
                      groupBy={(option) => option.type.replace("_", " ")}
                      value={searchValue}
                      inputValue={inputValue}
                      style={{background: "white"}}
                      open={open}
                      onOpen={() => {
                          setOpen(true);
                      }}
                      onClose={() => {
                          setOpen(false);
                      }}
                      isOptionEqualToValue={(option, value) => {
                          return option.code + " - " + option.name === value.code + " - " + value.name;
                      }}
                      filterOptions={(x) => x}
                      loading={!isSearchReady}
                      loadingText={"Loading..."}
                      onChange={(event, newValue, reason) => {
                          if (reason === "selectOption"){
                              const tempEdiType=newValue.filter((element)=> element.type==="EDI_Type");
                              if (tempEdiType.length==2){
                                  const tempNewValue=newValue.filter((element)=> (element.type==="EDI_Type" && element.code===tempEdiType[1].code) || (element.type!=="EDI_Type"));
                                  setSearchValue(tempNewValue);
                              }else {
                                  setSearchValue(newValue);
                              }

                              {/*if (searchValue.length === 0) {
                                  setSearchValue(newValue);
                              }*/}

                          }else if (reason === "removeOption") {
                              setSearchValue(newValue);
                          }

                      }}
                      onInputChange={(event, newValue, reason) => {
                          const value = removeLeadingZeros(newValue);
                          setInputValue(value);
                          if (reason === "input") {
                                  setValueToSearch(value);
                          }
                      }}
                      id="search_criteria" size="small" renderInput={
            (params) => <TextField {...params}
                                   placeholder="Search for Supplier, Unit or Transaction Type"
                                   slotProps={{
                                       ...params.slotProps,
                                       endAdornment: (
                                           <React.Fragment>
                                               {!searchReady ? <CircularProgress color="inherit" size={20} /> : null}
                                               {/*params.InputProps.endAdornment*/}
                                           </React.Fragment>
                                       ),
                                   }}
                        />
        }/>


    );
}
